module.exports = __webpack_public_path__ + "4874964f8cfb85281d426fcba3258013.jpg";